import { render, staticRenderFns } from "./Reservas.vue?vue&type=template&id=0c3c3dfe"
import script from "./Reservas.vue?vue&type=script&lang=js"
export * from "./Reservas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports